import classes from './CommonCard.module.css';

const CommonCard = ({children, className}) => {    
    return (
        <div className={`${classes.wrapper} ${className}`}>
            {children}
        </div>
    );
}
export default CommonCard;